module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (250).2b522131.jpg";